import { number, oneOf, oneOfType, string } from 'prop-types';
import { LOT_TO_UNIT } from '@context/stock/buysell/constants';

const getLimitOrderSide = (orderDetail) => {
  switch (orderDetail?.transaction_type) {
    case '1':
      return 'BUY';
    case '2':
      return 'SELL';
    default:
      return '';
  }
};

export const transformOrderDetail = (data) => {
  const { accountType, orderType, orderDetail } = data || {};
  switch (orderType) {
    case 'LIMIT':
      return {
        // General data
        order_id: orderDetail?.order_no,
        idx_order_id: orderDetail?.idx_order_no,
        status: orderDetail?.status_description,
        code: orderDetail?.stock,
        order_side: getLimitOrderSide(orderDetail),
        account_type: accountType,
        order_type: orderType,
        order_period: orderDetail?.period?.toUpperCase(),

        // Limit order data
        price: orderDetail?.price_order,
        lot_count: orderDetail?.lot_input,
        total: orderDetail?.total_price,
      };
    case 'AUTO':
      return {
        // General data
        order_id: orderDetail?.id,
        idx_order_id: '',
        status: orderDetail?.order_status,
        code: orderDetail?.code,
        order_side: orderDetail?.side,
        account_type: accountType,
        order_type: orderType,
        order_period: orderDetail?.period?.toUpperCase(),

        // Limit order data
        price: orderDetail?.order_price,
        lot_count: orderDetail?.lot,
        total: orderDetail?.order_price * orderDetail?.lot * LOT_TO_UNIT,

        // Auto order data
        start_date: new Date(orderDetail?.start_date),
        end_date: new Date(orderDetail?.end_date),
        threshold_comparator: orderDetail?.comparator,
        threshold_value: orderDetail?.value,
      };
    default:
      return {};
  }
};

export const ORDER_DETAIL_SHAPE = {
  order_id: oneOfType([string, number]),
  idx_order_id: oneOfType([string, number]),
  status: string,
  code: string,
  order_side: oneOf(['BUY', 'SELL']),
  account_type: oneOf(['REGULAR', 'DAY_TRADING', 'MARGIN_TRADING']),
  order_type: oneOf(['LIMIT', 'AUTO']),
  order_period: oneOf(['DAY', 'SESSION']),
  price: number,
  lot_count: number,
  total: number,
};
